import PaymentRequestButton from './PaymentRequestButton'

export default PaymentRequestButton
